




















































































import Vue from "vue";
import moment from "moment";
import type { GiftcardObject } from "@/views/customer-dashboard/types/index";
import { solveCurrencySymbol } from "@/common/common";
import StatusTag from "./StatusTag.vue";
import vIcon from "@/components/v-components/v-icon.vue";
import { formatPrice, formatDateAsDuration } from "@/utils/formatters";
import {
  getGiftcardStatus,
  getGiftcardStatusTagType
} from "@/utils/giftcards";
import type { GiftcardStatus } from "@/utils/giftcards";

export default Vue.extend({
  name: "GiftCardComponent",

  components: { StatusTag, vIcon },

  props: {
    giftcard: {
      type: Object as () => GiftcardObject,
      required: true
    }
  },

  data: () => {
    return {
      codeCopied: false
    };
  },

  computed: {
    title(): string {
      const title = this.giftcard.title;
      if (!title) return "";
      return title.en || title.fi || Object.values(title)[0] || "";
    },

    status(): GiftcardStatus {
      return getGiftcardStatus(this.giftcard);
    },

    statusTagType(): string {
      return getGiftcardStatusTagType(this.status);
    },

    /**
     * formatDateAsDuration counts down to a future date, so a lapsed card
     * came out as "Valid for: now". Past dates now say so instead.
     */
    validFor(): string {
      if (this.status === "expired")
        return this.$t("customer-dashboard.giftcard.expired").toString();

      return formatDateAsDuration(this.giftcard.valid_until);
    }
  },

  methods: {
    solveCurrencySymbol,

    formatDate(ts: number): string {
      if (!ts) return "-";
      return moment.unix(ts).format("DD.MM.YYYY");
    },

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.giftcard.card_code);
        this.codeCopied = true;

        setTimeout(() => (this.codeCopied = false), 1000);
      } catch (err) {
        console.error("could not copy to clipboard");
      }
    },

    formatBalance(balance: number): string | number {
      const locale = this.$i18n.locale;
      const currency = this.giftcard?.currency
        ? this.giftcard?.currency
        : "EUR";

      if (isNaN(balance)) return "";
      if (this.giftcard.type === "value")
        return formatPrice(balance, locale, currency);
      return `${balance}x`;
    }
  }
});
